import { parameterize } from '@sentry/remix';
import { useTranslation } from 'react-i18next';

import { useWebThemeContext } from '../Layout/Context/useWebThemeContext';
import Typography from '../Typography';

interface PolicyHelperProps {
  fontFamily?: string;
  utmSource?: any;
  text: string;
  url: string;
  utmMedium?: string;
  className?: string;
}

// biome-ignore lint/correctness/noUnusedVariables: Keeping for backwards compatibility
const PolicyHelper = ({ fontFamily, utmSource, url, utmMedium, className, text }: PolicyHelperProps) => {
  const { webTheme } = useWebThemeContext();
  const href = new URL(url);

  if (utmSource) {
    const source = parameterize(utmSource, '_');
    href.searchParams.append('utm_source', source);
  }

  if (utmMedium) {
    href.searchParams.append('utm_medium', utmMedium);
  }

  const urlToAppend = href.toString();

  return (
    <a
      href={urlToAppend}
      target="_blank"
      className="whitespace-nowrap underline underline-offset-1 hover:opacity-80"
      rel="noreferrer"
      style={{
        color: webTheme.footer_text_color,
      }}
    >
      <Typography className="!text-xs" weight="light" fontFamily={fontFamily} color={webTheme.footer_text_color}>
        {text}
      </Typography>
    </a>
  );
};

interface Props {
  textColor?: string;
  fontFamily?: string;
  utmSource?: any;
  utmMedium?: string;
  className?: string;
}

const TermsOfUse = ({ fontFamily, utmSource, utmMedium, className }: Props) => {
  const { t } = useTranslation();

  return (
    <PolicyHelper
      fontFamily={fontFamily}
      className={className}
      utmSource={utmSource}
      url={'https://beehiiv.com/tou'}
      utmMedium={utmMedium}
      text={t('footer.terms_of_use')}
    />
  );
};

// biome-ignore lint/correctness/noUnusedVariables: Keeping for backwards compatibility
const PrivacyPolicy = ({ textColor, fontFamily, utmSource, className }: Props) => {
  const { t } = useTranslation();

  return (
    <PolicyHelper
      className={className}
      fontFamily={fontFamily}
      utmSource={utmSource}
      url={'https://beehiiv.com/privacy'}
      text={t('footer.privacy_policy')}
    />
  );
};

export { PrivacyPolicy, TermsOfUse };
